<template>
  <v-container v-if="product">
    <v-row>
      <v-col cols="10" lg="8" xl="6" offset-lg="1" offset-xl="2">
        <v-btn class="greenb--text" @click="$router.go(-1)" text>
          <v-icon left>
            mdi-arrow-left
          </v-icon>
          Zurück
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" lg="5" xl="4" offset-lg="1" offset-xl="2">
        <zoom-on-hover 
          :img-normal="product.images[0].imageSrc"
          v-if="$vuetify.breakpoint.mdAndUp"
        ></zoom-on-hover>
        <v-img
          :src="product.images[0].imageSrc"
          :lazy-src="product.images[0].imageSml"
          v-else
        />
      </v-col>

      <v-col cols="12" sm="5" lg="4" xl="3">
        <v-card flat>
          <v-card-title class="mb-2">
            <h2 class="h2 greend--text">
              {{ product.title }}
            </h2>
          </v-card-title>
          <v-card-subtitle style="color: rgba(0, 0, 0, 0.6)" class="mb-8">
            {{ product.description }}
          </v-card-subtitle>
          <v-card-text>
            <h3 class="h3">
              Preis: {{ product.price.toFixed(2).replace(".", ",") }} €
            </h3>
            Gewicht: {{ product.size }}{{ product.sizeUnit }}<br />
            ({{
              ((product.price / product.size) * 100)
                .toFixed(2)
                .replace(".", ",")
            }}
            € / 100g)
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="qty"
                  :items="qtySelect"
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="Anzahl"
                  outlined
                  color="greend"
                ></v-select>
              </v-col>
              <v-col cols="8">
                <v-btn
                  :loading="loadingCart"
                  :disabled="loadingCart"
                  color="greend"
                  @click="addToCart(product, qty)"
                  x-large
                  class="white--text"
                >
                  <v-icon left>mdi-cart</v-icon>
                  In den Warenkorb
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon color="success">mdi-cart-check</v-icon>
                    </span>
                  </template>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-row>
            <v-col cols="12">
              <v-tabs v-model="tab" color="greend">
                <v-tab>Beschreibung</v-tab>
                <v-tab>Zubereitung</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <div
                        v-for="(text, index) in product.descriptionLong.split(
                          '\n'
                        )"
                        :key="index"
                        class="mb-2"
                      >
                        {{ text }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>{{ product.preparation }}</v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      product: null,
      tab: null,
      loader: null,
      loadingCart: false,
      qty: "1",
      qtySelect: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20"
      ]
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 1000);
      this.loader = null;
    }
  },
  props: {
    productTitle: String
  },
  mounted() {
    this.product = this.$store.state.products.find(product => {
      return product.title == this.productTitle;
    });
  },
  methods: {
    addToCart(index, quantity) {
      this.$ga.event("Cart", this.productTitle + " " + quantity + "x in Warenkorb gelegt (Produktseite)");
      this.loader = "loadingCart";
      quantity = Number(quantity);
      this.$store.commit("addItemToCart", { itemId: index, quantity });
      this.$store.commit("updateSnackbar", {
        show: true,
        message: index.title + " in den Warenkorb gelegt."
      });
    },
  }
};
</script>

<style scoped></style>
